/**
 * 공개 정적 문서(web/public/*.html) 본문 읽기 — 가입 화면 약관 박스용 (2026-10-26).
 *
 * 문서 정본은 정적 HTML 한 벌이라 SPA 에 문구를 복사하지 않고 같은 출처에서 받아 본문만 꺼낸다.
 * 제목(h1)·목차(.toc)·하단 링크(.foot)는 박스 안에서 쓸모가 없어 뺀다. 링크는 새 탭으로.
 */
export async function loadLegalDocBody(path: string): Promise<string> {
  const res = await fetch(path, { cache: "no-cache" });
  if (!res.ok) throw new Error(`${path} ${res.status}`);
  const html = await res.text();
  const main = new DOMParser().parseFromString(html, "text/html").querySelector("main");
  if (!main) throw new Error(`${path} 본문 없음`);
  main.querySelectorAll("h1, .toc, .foot, script, style").forEach((el) => el.remove());
  main.querySelectorAll("a").forEach((a) => {
    a.setAttribute("target", "_blank");
    a.setAttribute("rel", "noopener noreferrer");
  });
  return main.innerHTML;
}
